import Vue from 'vue'
import Router from 'vue-router'

import HomeIndex from '@/page/homeindex'
import Mentmo from '@/page/document/mentmo'
import Mentmoa from '@/page/document/mentmoa'
import Documenta from '@/page/document/documenta'
import Documenta_1 from '@/page/document/documenta_1'
import Documentb from '@/page/document/documentb'
import Documentc from '@/page/document/documentc'
import Documentd from '@/page/document/documentd'
import Documente from '@/page/document/documente'
import Documentf from '@/page/document/documentf'
import Documentg from '@/page/document/documentg'
import Documenth from '@/page/document/documenth'
import Documentj from '@/page/document/documentj'
import Documentk from '@/page/document/documentk'
import Documentl from '@/page/document/documentl'


import Documoa from '@/page/documo/documoa'
import Documob from '@/page/documo/documob'
import Documoc from '@/page/documo/documoc'
import Documod from '@/page/documo/documod'
import Documoe from '@/page/documo/documoe'
import Documof from '@/page/documo/documof'
import Documog from '@/page/documo/documog'


import Solua from '@/page/solu/solua'
import Solub from '@/page/solu/solub'
import Soluc from '@/page/solu/soluc'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomeIndex',
      component: HomeIndex
    },
    {
      path: '/Mentmo',
      name: 'Mentmo',
      component: Mentmo,
    },
    {
      path: '/Mentmoa',
      name: 'Mentmoa',
      component: Mentmoa,
    },
    
    {
      path: '/documoa',
      name: 'Documoa',
      component: Documoa
    },
    {
      path: '/documob',
      name: 'Documob',
      component: Documob
    },
    {
      path: '/documoc',
      name: 'Documoc',
      component: Documoc
    },
    {
      path: '/documod',
      name: 'Documod',
      component: Documod
    },
    {
      path: '/documoe',
      name: 'Documoe',
      component: Documoe
    },
    {
      path: '/documof',
      name: 'Documof',
      component: Documof
    },
    {
      path: '/documog',
      name: 'Documog',
      component: Documog
    },

    {
      path: '/documenta',
      name: 'Documenta',
      component: Documenta,
      children:[
        {
          path: '/documenta_1',
          name: 'Documenta_1',
          component: Documenta_1
        },
        {
          path: '/documentb',
          name: 'Documentb',
          component: Documentb
        },
        {
          path: '/documentc',
          name: 'Documentc',
          component: Documentc
        },
        {
          path: '/documentd',
          name: 'Documentd',
          component: Documentd
        },
        {
          path: '/documente',
          name: 'Documente',
          component: Documente
        },
        {
          path: '/documentf',
          name: 'Documentf',
          component: Documentf
        },
        {
          path: '/documentg',
          name: 'Documentg',
          component: Documentg
        },
      ]
    },

    
   
    {
      path: '/documenth',
      name: 'Documenth',
      component: Documenth
    },
    {
      path: '/documentj',
      name: 'Documentj',
      component: Documentj
    },
    {
      path: '/documentk',
      name: 'Documentk',
      component: Documentk
    },
    {
      path: '/documentl',
      name: 'Documentl',
      component: Documentl
    },
    {
      path: '/Solua',
      name: 'Solua',
      component: Solua
    },
    {
      path: '/Solub',
      name: 'Solub',
      component: Solub
    },
    {
      path: '/Soluc',
      name: 'Soluc',
      component: Soluc
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js